<template>
    <layout-page :nav-bar-show-logo-text="false">

        <page-breadcrumb v-if="!fetching" :hierarchy="breadCrumbs" />

        <template v-if="!fetching">
            <div class="container">
                <div class="mt-5 flex flex-col">
                    <div class="grid-flow-row lg:grid lg:auto-rows-max lg:grid-cols-[1fr,400px]">
                        <div class="row-span-1 w-full lg:pe-3 personal-page">
                            <h1>{{ agency.Name }}</h1>

                            <PPDescription v-if="showEmployerInfo" title="Employers">
                                {{ agency.EmployerDescription }}

                                <PPAdditionalServices 
                                    v-if="!fetching && hasAdditionalServicesForEmployers" 
                                    type="emp"
                                    :services="agency.AdditionalServicesForEmployers" />

                            </PPDescription>

                            <PPDescription v-if="showCandidateInfo" title="Candidates">
                                {{ agency.Description }}

                                <PPAdditionalServices 
                                    v-if="!fetching && hasAdditionalServicesForCandidates" 
                                    type="cnd"
                                    :services="agency.AdditionalServicesForCandidates" />

                            </PPDescription>

                        </div>
                        <div class="row-span-1 w-full flex-col space-y-4 lg:space-x-4 lg:flex">
                            <ContactOptions @contactOpen="onContactOpen"/>
                        </div>
                    </div>
                </div>

                <PPAdditionalInfo />

                <div id="contact-form-container"></div>

            </div>
        </template>

        <Loading v-else />

    </layout-page>
    <ContactSystem :open="contactSystemOpen" />
</template>

<script>

import LayoutPage from "Components/layouts/LayoutPage";
import NavBar from "Components/NavBar/NavBar";
import PageBreadcrumb from 'Components/PageBreadcrumb';
import Description from 'Components/PersonalPage/Description';
import AdditionalServices from 'Components/PersonalPage/AdditionalServices';
import AdditionalInfo from 'Components/PersonalPage/AdditionalInfo';
import ContactOptions from 'Components/PersonalPage/ContactOptions';
import ContactSystem from 'Components/ContactSystem';
import Loading from 'Components/Loading.vue';

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
    name: "PersonalPage",
    components: {
        PageBreadcrumb,
        LayoutPage,
        NavBar,
        ContactOptions,
        ContactSystem,
        'PPAdditionalInfo' : AdditionalInfo,
        'PPAdditionalServices' : AdditionalServices,
        'PPDescription' : Description,
        Loading
    },
    computed: {
        ...mapState('agency', ['parameters', 'agency', 'branches', 'fetching', 'fetched', 'location']),
        // ...mapState('search', ['location']),
        ...mapGetters('agency', [
            'showEmployerInfo','showCandidateInfo', 'hasAdditionalServicesForEmployers',
            'hasAdditionalServicesForCandidates'
        ]),
        ...mapGetters('contact', [ 'branchSelected' ]),
        ...mapState('contact', {
            contactSystemOpen: 'open',
            branch: 'branch',
        }),
        breadCrumbs : function(){
          return [
            {
              name: 'Recruitment Agencies'
            },
            {
              name: this.agency.Name
            }
          ]
        }
    },
    methods: {
        ...mapActions('agency', ['loadInfo']),
        ...mapMutations('agency', ['setFetching', 'setFetched']),
        ...mapActions('contact', ['setAgency', 'loadPersistentInformation', 'triggerTrackingEvent']),
        ...mapMutations('contact', [
            'loadDefaultParameters',
            'setCallingPage',
            'setContactFormType',
            'setContactSocialType',
            'setContactEnquiryType',
            'setOpen',
            'setParameter',
            'setShouldPreselectBranch',
            'setSearchId',
            'setShouldRegister',
            'setStatic',
        ]),
        onContactOpen(event) {
            console.log(event);
            this.loadDefaultParameters();
            this.setContactFormType(event.form);
            this.setContactEnquiryType(event.type);
            this.setContactSocialType(event.social);
            this.setAgency(this.agency);
            this.setCallingPage(document.location.href);
            this.setSearchId(this.parameters.search_id);

            this.setStatic(this.static); 

            console.log("*** Personal page contact system opening ***");
            console.log("location:"); console.log(this.location);

            console.log(this.branchSelected);
            console.log(this.branch);
        
            /**
             * Ultimately this is how V2 does it but if we came from a search, should
             * we not try and select the branch associated with the search or
             * previous page's location?
             */
            this.setShouldPreselectBranch(
                this.location !== null && this.branches.length !== 0 && this.branchSelected
            );
            //this.setShouldPreselectBranch(false);

            if (this.parameters.emp_cand) {
                this.setParameter({ key: 'emp_cand', value: this.parameters.emp_cand });
            }

            this.loadPersistentInformation();
            this.setShouldRegister();
            this.triggerTrackingEvent();
            console.log('*** Personal page contact system opening return ***');
            this.setOpen();

        },
    },
    // beforeMount() {
    //     console.log('entering beforeMount');
    //     this.setFetching();
    // },
    // mounted() {
    //     console.log('entering mounted');
    //     console.log(`fetching: ${this.fetching}, fetched: ${this.fetched}`);
    //     // this.loadInfo(window.location);

    // },
    beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            if (from.name === undefined) {
                console.log("Personal Page: Refresh/entry point - SSR should have the data");
                return;
            } else {
                console.log("Personal Page: Transition from listing - go fetch data");
                vm.setFetching();
                vm.loadInfo(window.location);
            }
        })
    },
    beforeRouteLeave(to, from, next) {
        console.log("Personal Page: Leaving - ensure contact form closed");
        this.setOpen(false);
        next();
    }
};

</script>
